import styled from "styled-components";
import media from "styled-media-query";

export const Modal = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: var(--app-height);

  display: ${({ open }) => (open ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 3;
`;

export const Background = styled.div`
  position: fixed;
  width: 100vw;
  height: var(--app-height);

  background: ${({ theme }) => theme.colors.neutral.black}90;
  backdrop-filter: blur(4px);
`;

export const ModalWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.white};
  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};

  display: flex;
  flex-direction: column;

  width: 90vw;
  max-width: 900px;
  max-height: 90vh;

  border-radius: 24px 24px 0 0;
  overflow: hidden;
  z-index: 1;
  position: absolute;
  bottom: 0;

  ${media.greaterThan("medium")`
    border-radius: 24px;
    position: static;
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  padding: 24px 32px;
  background-color: ${({ theme }) => theme.colors.primary.cetaceanBlue};
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${({ theme }) => theme.font.heading.xs};
  font-weight: ${({ theme }) => theme.font.weight.medium};
`;

export const Close = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${({ theme }) => theme.font.body.md};
`;

export const Content = styled.div`
  padding: 24px 32px;
  overflow: auto;
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${({ theme }) => theme.font.body.md};
`;
